export const DEFAULT_REACT_QUERY_REFETCH_INTERVAL = 600000; //10 minutes
